'use client';

import { useEffect } from 'react';

// reCAPTCHA site key
export const RECAPTCHA_SITE_KEY = '6LdtQy4gAAAAAJx3BNX1a71NmWwgpCvqjha-z8jO';

interface Grecaptcha {
  ready: (callback: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
}

declare global {
  interface Window {
    grecaptcha: Grecaptcha;
    onRecaptchaLoad: () => void;
  }
}

export default function RecaptchaScript() {
  useEffect(() => {
    // Only add the script if it doesn't already exist
    if (!document.querySelector(`script[src*="recaptcha"]`)) {
      // Create script element
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      
      // Add script to the document
      document.head.appendChild(script);
    }
    
    return () => {
      // Cleanup if needed
    };
  }, []);

  return null; // This component doesn't render anything
}

// Helper function to execute reCAPTCHA and get a token
export const executeRecaptcha = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      reject(new Error('reCAPTCHA not loaded'));
      return;
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(RECAPTCHA_SITE_KEY, { action: 'submit' })
        .then(resolve)
        .catch(reject);
    });
  });
};